import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'ui-atom-spacer',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './ui-atom-spacer.component.html',
  styleUrl: './ui-atom-spacer.component.scss'
})
export class UiAtomSpacerComponent {

  @Input() size: 'spacer-regular' | 'spacer-xxl' | 'spacer-xxxl' = 'spacer-regular';

}
